import { Component } from 'react';
import I18n from 'I18n';
import PropTypes from 'prop-types';
import LinkFormPagesSelector from './LinkFormPagesSelector';
import { PopoverFooter, PopoverHeader, PopoverBody } from 'foundations-components/transitional/components/Popover';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import { Link } from 'foundations-components/transitional/components/Link';
import { ENTER, ESCAPE } from '../utils/keyCodes';
import { Small } from 'foundations-components/transitional/components/Small';
import { View } from 'foundations-components/components/View';
import { TextInput } from 'foundations-components/transitional/components/TextInput';
import { FormControl } from 'foundations-components/transitional/components/FormControl';
import { Checkbox } from 'foundations-components/transitional/components/Checkbox';
import { Button } from 'foundations-components/transitional/components/Button';
import { AppProvider } from 'foundations-components/components/AppProvider';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const toI18nText = name => I18n.text(`draftPlugins.linkPlugin.${name}`);
const POPOVER_WIDTH = 328;
const PAGES_POPOVER_WIDTH = 425;
export default class LinkForm extends Component {
  constructor(...args) {
    super(...args);
    this.cancelOrConfirmKeys = e => {
      switch (e.keyCode) {
        case ESCAPE:
          e.preventDefault();
          this.props.onCancel();
          return;
        case ENTER:
          e.preventDefault();
          if (this.canSubmit()) {
            this.props.onConfirm();
            return;
          }
          return;
        default:
          return;
      }
    };
    this.handleTextChange = e => {
      e.stopPropagation();
      const {
        value
      } = e.target;
      this.props.onChange({
        text: value
      });
    };
    this.handleUrlChange = e => {
      e.stopPropagation();
      const {
        value
      } = e.target;
      const {
        url,
        text,
        showText
      } = this.props;
      const {
        onChange
      } = this.props;
      if (showText && url === text) {
        onChange({
          url: value,
          text: value
        });
        return;
      }
      onChange({
        url: value
      });
    };
    this.handleNoFollowChange = e => {
      e.stopPropagation();
      this.props.onChange({
        isNoFollow: e.target.checked
      });
    };
    this.handleTargetChange = e => {
      e.stopPropagation();
      this.props.onChange({
        isTargetBlank: e.target.checked
      });
    };
    this.canSubmit = () => {
      const {
        showText,
        text,
        url
      } = this.props;
      // eslint-disable-next-line no-script-url
      const doesNotContainScript = url && url.indexOf('javascript:') === -1;
      const textIsNotEmpty = !showText || text && text.trim().length > 0;
      const urlIsNotEmpty = url && url.trim().length > 0;
      return urlIsNotEmpty && textIsNotEmpty && doesNotContainScript;
    };
    this.shouldDisplayPages = () => {
      return this.props.pages.length > 0;
    };
    this.renderFooter = () => {
      const {
        isNew,
        onCancel,
        onConfirm
      } = this.props;
      const saveText = isNew ? toI18nText('apply') : toI18nText('save');
      return /*#__PURE__*/_jsxs(PopoverFooter, {
        paddingBlockStart: "400",
        children: [/*#__PURE__*/_jsx(Button, {
          use: "primary",
          size: "extra-small",
          "data-selenium-test": "communicator-link-apply",
          disabled: !this.canSubmit(),
          onClick: onConfirm,
          children: saveText
        }), /*#__PURE__*/_jsx(Button, {
          use: "tertiary-light",
          size: "extra-small",
          onClick: () => onCancel(),
          children: toI18nText('cancel')
        }), this.renderRemove()]
      });
    };
    this.renderVisitLink = () => {
      const {
        isNew,
        url
      } = this.props;
      if (!isNew) {
        return /*#__PURE__*/_jsx(Link, {
          href: url,
          external: true,
          children: toI18nText('visitLink')
        });
      }
      return null;
    };
    this.renderText = () => {
      const {
        text,
        showText
      } = this.props;
      if (!showText) {
        return null;
      }
      return /*#__PURE__*/_jsx(FormControl, {
        label: toI18nText('text'),
        marginBlockStart: "100",
        children: /*#__PURE__*/_jsx(TextInput, {
          "data-selenium-test": "communicator-link-text",
          onChange: this.handleTextChange,
          onKeyDown: this.cancelOrConfirmKeys,
          value: text
        })
      });
    };
    this.renderNoFollow = () => {
      const {
        isNoFollow,
        hideNoFollowConfiguration
      } = this.props;
      return hideNoFollowConfiguration ? null : /*#__PURE__*/_jsx(FormControl, {
        marginBlockStart: "200",
        children: /*#__PURE__*/_jsx(Checkbox, {
          checked: isNoFollow,
          "data-test-id": "toggle-no-follow",
          onChange: this.handleNoFollowChange,
          innerPadding: "none",
          children: /*#__PURE__*/_jsx(Small, {
            children: toI18nText('noFollow')
          })
        })
      });
    };
    this.renderTarget = () => {
      const {
        isTargetBlank,
        hideTargetConfiguration
      } = this.props;
      return hideTargetConfiguration ? null : /*#__PURE__*/_jsx(FormControl, {
        marginBlockStart: "200",
        children: /*#__PURE__*/_jsx(Checkbox, {
          checked: isTargetBlank,
          "data-test-id": "toggle-target",
          onChange: this.handleTargetChange,
          innerPadding: "none",
          children: /*#__PURE__*/_jsx(Small, {
            children: toI18nText('openInNewTab')
          })
        })
      });
    };
    this.renderRemove = () => {
      const {
        isNew,
        onRemove
      } = this.props;
      if (!isNew) {
        return /*#__PURE__*/_jsx(Button, {
          use: "link",
          marginInlineStart: "200",
          onClick: onRemove,
          children: toI18nText('removeLink')
        });
      }
      return null;
    };
    this.renderHeader = () => {
      const {
        isNew
      } = this.props;
      let {
        headerText
      } = this.props;
      if (isNew) {
        headerText = toI18nText('newLink');
      }
      return /*#__PURE__*/_jsx(PopoverHeader, {
        children: /*#__PURE__*/_jsxs(TFlex, {
          flexDirection: "row",
          alignItems: "baseline",
          justifyContent: "space-between",
          children: [/*#__PURE__*/_jsx("h5", {
            children: headerText || toI18nText('editLink')
          }), this.renderVisitLink()]
        })
      });
    };
    this.renderUrl = () => {
      const {
        onChange,
        pages,
        showText,
        text,
        url
      } = this.props;
      if (this.shouldDisplayPages()) {
        return /*#__PURE__*/_jsx(LinkFormPagesSelector, {
          onChange: onChange,
          pages: pages,
          showText: showText,
          text: text,
          url: url
        });
      }
      return /*#__PURE__*/_jsx(FormControl, {
        label: toI18nText('url'),
        marginBlockStart: "100",
        children: /*#__PURE__*/_jsx(TextInput, {
          autoFocus: true,
          "data-selenium-test": "communicator-link-url",
          onChange: this.handleUrlChange,
          onKeyDown: this.cancelOrConfirmKeys,
          value: url
        })
      });
    };
  }
  render() {
    const {
      onConfirm
    } = this.props;
    const width = this.shouldDisplayPages() ? PAGES_POPOVER_WIDTH : POPOVER_WIDTH;
    return /*#__PURE__*/_jsx(AppProvider, {
      children: /*#__PURE__*/_jsxs("div", {
        style: {
          width
        },
        children: [this.renderHeader(), /*#__PURE__*/_jsx(PopoverBody, {
          paddingBlockStart: "200",
          children: /*#__PURE__*/_jsxs("form", {
            onSubmit: onConfirm,
            children: [this.renderText(), this.renderUrl(), /*#__PURE__*/_jsxs(View, {
              marginBlockStart: "200",
              as: "div",
              children: [this.renderTarget(), this.renderNoFollow()]
            })]
          })
        }), this.renderFooter()]
      })
    });
  }
}
LinkForm.propTypes = {
  isNew: PropTypes.bool.isRequired,
  headerText: PropTypes.string.isRequired,
  text: PropTypes.string,
  url: PropTypes.string.isRequired,
  pages: PropTypes.array.isRequired,
  isTargetBlank: PropTypes.bool.isRequired,
  isNoFollow: PropTypes.bool.isRequired,
  showText: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  onRemove: PropTypes.func.isRequired,
  hideTargetConfiguration: PropTypes.bool,
  hideNoFollowConfiguration: PropTypes.bool
};
LinkForm.defaultProps = {
  headerText: '',
  pages: [],
  showText: true,
  hideTargetConfiguration: false,
  hideNoFollowConfiguration: false
};